import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {AppConfig} from '../../../AppConfig'
import {appUrl} from '../../../AppUrl'
import {AnalyticsEventReporter} from '../../../helpers/AnalyticsEventReporter'
import {useAccountFlagsStore} from '../../../stores'

interface Props {
    className?: string
    utmSource?: string
    gridOrder?: number
    colSpan?: number
    size?: 'sm' | 'md' | 'lg'
}

// Получить аванс на объявление.
export function GetAdvancePromoCard(props: Props) {
    const {
        className,
        utmSource = 'promo_banners_block',
        gridOrder = 0,
        colSpan,
        size,
    } = props

    const isSeller: boolean = useAccountFlagsStore(
        state => state.isSeller
    )

    if (!isSeller || !AppConfig.features.advances?.quickAdvancePage) {
        return null
    }

    const url = NavigationService.makeFullUrl(
        appUrl().quickAdvance.landing,
        null,
        {utm_source: utmSource}
    )

    return (
        <Card
            className={clsx('promo-card get-advance cursor', size, className)}
            style={{
                order: gridOrder,
                gridColumn: colSpan ? `span ${colSpan}` : undefined,
            }}
            onClick={() => {
                AnalyticsEventReporter.promoBannerClick('get_advance', utmSource)
                window.open(url, '_blank')
            }}
        >
            <CardBody>
                <div>
                    <div className="promo-card-text-wrapper">
                        <div className="promo-card-heading">
                            {trans().common.promo.get_advance.header}
                        </div>
                    </div>
                    <Button
                        color="blue"
                        className="text-nowrap"
                        href={url}
                        target="_blank"
                    >
                        {trans().common.promo.get_advance.button}
                    </Button>
                </div>
            </CardBody>
        </Card>
    )
}
